import { monthLabel } from '../model/months'
import type { AccountAsOf } from '../model/portfolioOverview'
import { statementsStartText, unreadStatementText } from '../portfolioText'

// Said where the value would be when the month has none.
export const noValueText = (account: AccountAsOf): string | null => {
  const month = monthLabel(account.month)
  if (account.status === 'before_first_statement') {
    return statementsStartText(account)
  }
  if (account.status === 'missing') return `No statement for ${month}`
  if (account.status === 'two_statements') return `Two statements for ${month}`
  if (account.status === 'verifying') return `${month} statement being verified`
  if (account.status === 'mid_cycle') return `No statement ends in ${month}`
  if (account.status === 'failed_read') {
    return `${unreadStatementText(account)}.`
  }
  if (account.value == null) return `No value for ${month}`
  return null
}
